import initAssignment from './actions/initAssignment';
import removeAssignments from './actions/removeAssignment';
import setActiveAssignment from './actions/setActiveAssignment';
import toggleAssignment from './actions/toggleAssignment';
export default function assignmentReducer(state, action) {
    switch (action.type) {
        case 'INITIATE_ASSIGNMENTS': {
            return initAssignment(action);
        }
        case 'REMOVE': {
            const { axis, ids, atomID } = action.payload;
            return removeAssignments(state, { axis, ids, atomID });
        }
        case 'TOGGLE': {
            return toggleAssignment(state, action);
        }
        case 'SET_ACTIVE': {
            return setActiveAssignment(state, action);
        }
        case 'SHOW': {
            const { id, axis } = action.payload;
            return {
                ...state,
                highlighted: {
                    id,
                    axis: axis || null,
                },
            };
        }
        case 'HIDE': {
            return {
                ...state,
                highlighted: null,
            };
        }
        default:
            return state;
    }
}
